export const protoMeta = (token: string | null, clientID: string | null) => ({
  authorization: token,
  language: 'zh-CN',
  'client-id': clientID,
  'device-type': 'web',
});
